import { render, staticRenderFns } from "./InstaBlock.vue?vue&type=template&id=1cb90a63&"
import script from "./InstaBlock.vue?vue&type=script&lang=js&"
export * from "./InstaBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports